import Vue from 'vue'
import VueGridLayout from 'vue-grid-layout'

Vue.component('grid-layout', VueGridLayout.GridLayout)
Vue.component('grid-item', VueGridLayout.GridItem)
